<template>
  <el-image v-if="isLazy" v-bind="$attrs" :src="imgUrl" :key="guid()" :alt="$attrs.alt" lazy></el-image>
  <img v-else v-bind="$attrs" :src="imgUrl" :alt="$attrs.alt" lazy>
</template>

<script>
import { guid } from '@/util/uuid'
const isSupportWebp = (() => {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0
  } catch (err) {
    return false
  }
})()

export default {
  props: {
    src: {
      type: String,
      require: true,
      default: ''
    },
    width: {
      type: Number,
      default: 0
    },
    height: {
      type: Number,
      default: 0
    },
    scale: {
      type: Number,
      default: 2
    },
    mType: {
      type: String,
      default: 'fill' // lfit,mfit,fill,pad,fixed（只知道宽，高的一个传此类型。lfit：图片按比例缩放）
    },
    isLazy: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      replaceList: ['hbo-shenzhen.oss-accelerate.aliyuncs.com', 'hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com']
    }
  },
  computed: {
    imgUrl() {
      let src = this.src.replace(/\?{1}.*/g, '')
      const width = ~~(this.width * this.scale)
      const height = ~~(this.height * this.scale)
      src += `?x-oss-process=image/resize,w_${width},h_${height},m_${this.mType}`
      if (isSupportWebp) {
        src += `/format,webp`
      }
      return this.replaceUrl(src)
    }
  },
  methods: {
    // 替换成有cdn更快的链接
    replaceUrl(src) {
      let index = -1
      this.replaceList.forEach((t, i) => {
        src.includes(t) && (index = i)
      })
      return (index === -1 ? src : src.replace(this.replaceList[index], 'img.kakaclo.com'))
    },
    guid
  }
}
</script>

<style lang="scss" scoped>

</style>
